"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AppContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _nanoid = require("nanoid");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _window, _window$globalConfig;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var appId = (0, _nanoid.nanoid)();
var AppContext = /*#__PURE__*/(0, _react.createContext)({
  liveClickerSettings: (_window = window) === null || _window === void 0 ? void 0 : (_window$globalConfig = _window.globalConfig) === null || _window$globalConfig === void 0 ? void 0 : _window$globalConfig.liveClicker
});
exports.AppContext = AppContext;

var AppProvider = function AppProvider(_ref) {
  var children = _ref.children,
      lcSettings = _ref.liveClickerSettings;

  var _useState = (0, _react.useState)(lcSettings),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      liveClickerSettings = _useState2[0],
      setLiveClickerSettings = _useState2[1];

  (0, _react.useEffect)(function () {
    setLiveClickerSettings(lcSettings);
  }, [lcSettings]);

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("main", {
    id: appId,
    className: "gcc-app"
  }, /*#__PURE__*/_react["default"].createElement(AppContext.Provider, {
    value: {
      appId: appId,
      liveClickerSettings: liveClickerSettings,
      setLiveClickerSettings: setLiveClickerSettings
    }
  }, children));
};

AppProvider.defaultProps = {
  liveClickerSettings: undefined
};
AppProvider.propTypes = {
  children: _propTypes.node.isRequired,
  liveClickerSettings: (0, _propTypes.shape)({
    apiKey: _propTypes.string.isRequired,
    clientId: _propTypes.number.isRequired,
    componentId: _propTypes.number.isRequired,
    playerIdProduct: _propTypes.number.isRequired,
    playerIdConfigurator: _propTypes.number.isRequired,
    playerIdContent: _propTypes.number.isRequired
  })
};
AppProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppProvider",
  "props": {
    "liveClickerSettings": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "apiKey": {
            "name": "string",
            "required": true
          },
          "clientId": {
            "name": "number",
            "required": true
          },
          "componentId": {
            "name": "number",
            "required": true
          },
          "playerIdProduct": {
            "name": "number",
            "required": true
          },
          "playerIdConfigurator": {
            "name": "number",
            "required": true
          },
          "playerIdContent": {
            "name": "number",
            "required": true
          }
        }
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = AppProvider;
exports["default"] = _default;